export default "__VITE_ASSET__CTMlJJ5c__"